import { Button, Layout, TextField } from "matsuri-ui"
import { FormEvent, useCallback } from "react"
import { css } from "@emotion/react"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useTranslation } from "@/hooks/useTranslation"

const Logo = () => {
    return (
        <div
            css={css`
                display: grid;
                place-items: center;
                margin: 16px;
            `}
        >
            <img
                src="./assets/logo.png"
                css={css`
                    max-width: min(250px, 50%);
                `}
            />
        </div>
    )
}

export const Login = () => {
    const { login } = useAuth()
    const { t } = useTranslation()
    const onSubmit = useCallback(
        async (event: FormEvent<HTMLFormElement>) => {
            event.preventDefault()
            const formData = new FormData(event.currentTarget)
            const input = Object.fromEntries(formData)

            const { error, token } = await login({
                email: input.email as string,
                password: input.password as string
            })
            if (error) {
                const errorMessage = error.message || error.toString()
                if (errorMessage.includes("invalid_login_info")) {
                    window.alert(
                        t(`メールアドレスとパスワードの組み合わせが違います。`)
                    )
                } else {
                    window.alert(t(`エラーが発生しました: ${errorMessage}`))
                }
            }
        },
        [login, t]
    )

    return (
        <main
            css={css`
                padding: 1em;
            `}
        >
            <Logo />
            <form onSubmit={onSubmit}>
                <Layout.Column gap={4}>
                    <TextField
                        label={t("メールアドレス")}
                        name="email"
                        type="email"
                        autoComplete="email"
                    />
                    <TextField
                        label={t("パスワード")}
                        name="password"
                        type="password"
                        autoComplete="current-password"
                    />
                    <Layout.Row justify="space-between">
                        <Button
                            as="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            size="small"
                            href={process.env.RESET_PASSWORD_REQUEST_URL}
                        >
                            {t("パスワードを忘れた場合")}
                        </Button>
                        <Button variant="filled" color="primary" type="submit">
                            {t("ログイン")}
                        </Button>
                    </Layout.Row>
                </Layout.Column>
            </form>
        </main>
    )
}
